var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"color-block",style:(_vm.colors[_vm.color])},[_c('div',[_c('i'),(_vm.showLabel)?[_vm._v(" "+_vm._s({ '哑光黑油': '哑黑', '哑光绿油': '哑绿' }[_vm.color] || _vm.color)+" ")]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }